import { smoothScrollTo } from './scrollUtils.js'

window.addEventListener('DOMContentLoaded', () => {
  const links = document.querySelectorAll('a[href^="#"]')

  let margin = 80
  // PCの場合
  if (window.innerWidth >= 989) {
    margin = 150
  }

  links.forEach((link) =>{
    link.addEventListener('click', (e) => {
      e.preventDefault()
      const hrefLink = link.getAttribute("href")
      const targetContent = document.getElementById(hrefLink.replace("#", ""))
      const rectTop = targetContent.getBoundingClientRect().bottom
      const start = window.scrollY
      const target = rectTop + start - margin
      smoothScrollTo(target, start)
    })
  })
})
